module.exports = __webpack_public_path__ + "img/mesa_ls03n.503ef61b.png";